'use strict';

var contactus = {
	initContactDirectTracker: function () {
		$('.pt_customer-service .telephone-and-email-section').on('click', '.toggle-title', function () {
			var obj = {
				'button_ID': $(this).target.id ? $(this).target.id : $(this).target.innerText,
				'contact_business_area': $(this).text(),
				'contact_type': 'telephone&email',
				'event': 'contactDirect'
			};
			dataLayer.push(obj);
		});
	},
	initContactAddressTracker: function () {
		$('.pt_customer-service .address-section').on('click', '.toggle-title', function () {
			var obj = {
				'button_ID': $(this).target.id ? $(this).target.id : $(this).target.innerText,
				'contact_location': $(this).text(),
				'contact_type': 'address',
				'event': 'contactAddress'
			};
			dataLayer.push(obj);
		});
	},
	initContactEmailTracker: function () {
		$('.pt_customer-service .telephone-and-email-section').on('click', 'a', function () {
			if ($(this).attr('href').indexOf('mailto') !== -1) {
				var obj = {
					'button_ID': $(this).target.id ? $(this).target.id : $(this).target.innerText,
					'contact_business_area': $(this).closest('.toggle-information').children().first().text(),
					'contact_email_clicked': $(this).text(),
					'contact_type': 'telephone&email',
					'event': 'contactEmail'
				};
				dataLayer.push(obj);
			}
		});
	},
	initContactFaqTracker: function () {
		$('#specific-subtopic-faqs').on('click', 'a', function () {
			var obj = {
				'button_ID': $(this).target.id ? $(this).target.id : $(this).target.innerText,
				'contact_business_area': $('select[name$=_contactus_businessarea]').val(),
				'contact_faq': $(this).text(),
				'contact_reason':$('select[name$=_contactus_reason]').val(),
				'contact_type': 'form',
				'event': 'contactFAQ'
			};
			dataLayer.push(obj);
		});
	}
};

module.exports = contactus;
